module.exports = __webpack_public_path__ + "img/cycle_on.f4178cf1.svg";